module.exports = __webpack_public_path__ + "static/media/ss.86e7ab79.svg";